// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "web-worker/" + ({"351":"lazy-actions","369":"wix-comments-controller","639":"localization-api","806":"members-v3-follow","928":"duplexer"}[chunkId] || chunkId) + ".chunk.min.js";
};